<template>
  <Header/>
  <div id="main" class="width">
    <LeftSide/>

    <div class="nright" style="margin-top: 10px;">
      <div id="Div3">
        <h3 class="title"><strong>{{ domTitle }}</strong></h3>
        <div class="list">
          <ul class="artlist" style="line-height: 1.5;">

            <li v-for="(item, index) in listData" :key="index">
              <span>[{{ item.post_date.split(" ")[0] }}]</span>
              <a :href="'/#/detail?id=' + item.ID" target='_blank'
                 :title='item.post_title'>
                {{ item.post_title }}
              </a>
            </li>

          </ul>
          <div class="pages">
            <PageFen :currentPage="pageNow" :showItemPerPage="6" :totalPage="pageTotal" :callBack="_pageChange"/>
          </div>
        </div>

      </div>
    </div>
  </div>
  <Footer/>
</template>

<script>
import Header from "@/components/Header"
import PageFen from "@/components/PageFen"
import Footer from "@/components/Footer"
import LeftSide from "@/components/LeftSide"
import http from "@/util/http"

export default {
  name: "ListPage",
  components: {LeftSide, Footer, PageFen, Header},
  data() {
    return {
      pageNow: 1,
      pageTotal: 18,

      queryData: {
        parent: undefined,
        page: 1
      },
      listData:[],
      domTitle: undefined,
      navList: [
        {
          id: 0,
          pathName: 'home',
          select: true,
          path: '/',
          label: '首页'
        },
        {
          id: 1,
          pathName: 'shiShiXinWen',
          select: false,
          path: '/#/shiShiXinWen',
          label: '时事新闻'
        },
        {
          id: 2,
          pathName: 'hangYeZiXun',
          select: false,
          path: '/#/hangYeZiXun',
          label: '行业资讯'
        },
        {
          id: 3,
          pathName: 'gaoXinJiShu',
          select: false,
          path: '/#/gaoXinJiShu',
          label: '高新技术'
        },
        {
          id: 4,
          pathName: 'guoNeiZiXun',
          select: false,
          path: '/#/guoNeiZiXun',
          label: '国内资讯'
        },
        {
          id: 5,
          pathName: 'quanQiuZiXun',
          select: false,
          path: '/#/quanQiuZiXun',
          label: '全球资讯'
        },
        {
          id: 6,
          pathName: 'huLianWangJiaNews',
          select: false,
          path: '/#/huLianWangJiaNews',
          label: '互联网+新闻'
        },
        {
          id: 7,
          pathName: 'hangYeHuoDong',
          select: false,
          path: '/#/hangYeHuoDong',
          label: '行业活动'
        }
      ]
    }
  },
  mounted() {
    this._domTitle()
  },
  methods: {
    _pageChange(e) {
      this.queryData.page = e
      this._getList()
    },
    _domTitle() {
      const routeName = this.$route.name
      for (const i in this.navList) {
        if (this.navList[i].pathName === routeName) {
          this.domTitle = this.navList[i].label
          this.queryData.parent = this.navList[i].id
          break
        }
      }
      this._getList()
    },
    _getList() {
      http.get('listPage', {
        parent: this.queryData.parent,
        page: this.queryData.page
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.listData = res.data.data.list
              this.pageTotal = res.data.data.pageTotal
            }
          })
    }
  }
}
</script>

<style scoped>

</style>